export default __webpack_public_path__ + "static/media/homeIntroTextLeftPolygon.5017e6cc.svg";